export class State{
    url: string;
    data: any;
    selectedId: any;
    key: string;
    subStates: Array<State> = [];
    selectedType: string;

    constructor(_key: string, _url: string, _data: any, _selectedId: any, _subStates?: Array<State>, _selectedType?: string){
        this.key = _key;
        this.url = _url;
        this.data = _data;
        this.selectedId = _selectedId;
        this.subStates = _subStates || [];
        this.selectedType = _selectedType || '';
    }

    addSubState(state){
        this.subStates.push(state);
    }

    popSubState(){
        const subState = this.subStates[this.subStates.length - 1];
        this.subStates.splice(this.subStates.length - 1, 1);
        return subState;
    }

    getLastSubState(){
        if (!this.subStates || this.subStates.length == 0){
            return {};
        }
        return this.subStates[this.subStates.length - 1];
    }
}
